import React from 'react';
import { Text, Link } from '@chakra-ui/react';
import InfoSection from '../../components/shared/InfoSection';

const INFO_ITEMS = [
  {
    title: 'Measurements',
    description: (
      <Text as="span">
        ‘To-the-inch’ accuracy on all{' '}
        <Link href="/measurements_overview/">
          complete exterior measurements
        </Link>{' '}
        including all roofing, siding, windows, surface areas, and openings.
      </Text>
    ),
  },
  {
    title: 'Interactive 3D Model',
    description:
      'All the measurements and drawings of each elevation a home improvement professional needs. Soffit, fascia, and flashing are all easily viewed leading to faster, more accurate and transparent estimations.',
  },
  {
    title: 'Property Portfolio',
    description:
      'Take pictures in any order and capture as many as you like. Review and edit before you submit to build the 3D model. Document your property with free photo storage.',
  },
  {
    title: 'Photo Capture & Storage',
    description:
      'Take pictures in any order and capture as many as you like. Review and edit before you submit to build the 3D model. Document your property with free photo storage.',
  },

  {
    title: 'Interactive Design',
    description:
      'Try new finishes and colors in a precise 3D model of your home. Add stone facade, special accents like shakes in a gable, replace stucco or explore new color combinations.',
  },
  {
    title: 'Single or Multi-Family Homes',
    description:
      'HOVER works for single-family homes, townhomes, and multi-family residential properties. Tight lot lines, urban or rural areas even with some vegetation or obstructions.',
  },
  {
    title: 'HOVER Prospect',
    description:
      'Capture and store property photos at no cost, and order the measurements and 3D model at any time in the future.',
  },
  {
    title: 'HOVER Connect',
    description: (
      <Text as="span">
        Invite homeowners to take photos of their own home for a remote estimate
        or simply to get the 3D model and complete measurements before your
        first meeting.{' '}
        <Link href="https://hover.wistia.com/medias/22o3cdkwp9">
          Learn More
        </Link>
      </Text>
    ),
  },

  {
    title: 'Data Exports',
    description:
      'Export your measurements to help with estimation in PDF, Excel, JSON or XML formats. Export your 3D model into popular CAD types: SKP, DXF, DWG. Export all of your photos to your computer.',
  },
  {
    title: 'Workflow Integrations',
    description: (
      <Text as="span">
        From CRM to Project Management to Estimation, our integration partners
        help you to streamline your workflow.{' '}
        <Link href="/blog/get-done-faster-integrations/">
          See our partner integrations
        </Link>
        .
      </Text>
    ),
  },
  {
    title: 'Pro Connect',
    description:
      'Invite anyone in your company with Pro Connect for maximum workflow flexibility.',
  },
  {
    title: 'Multi-Platform Sync',
    description:
      'Works seamlessly across your computer and smartphone device. Access your HOVER data from the field or home office anywhere, anytime, on any Apple or Android device.',
  },
  {
    title: '*NEW* Estimation',
    description:
      'Accurate estimates for multiple trades in seconds that reflect job complexity and custom pricing.',
  },

  {
    title: '*NEW* Proposals and Contracts',
    description:
      'Generate proposals in your custom template without manual entry and get digital signatures while on site.',
  },
  {
    title: '*NEW* Production Console',
    description:
      'All the resources you need to complete a job in a central location, from detailed take-offs and contracts to measurements and job economics.',
  },
  {
    title: '*NEW* Supplier-direct Ordering',
    description:
      'Seamlessly order from leading suppliers like Beacon Pro+ with one click and your material lists automatically populate your cart for easy checkout without leaving the HOVER platform.',
  },
  {
    title: '*NEW* Materials Ordering',
    description:
      'Precise, pre-populated material lists for multiple trades that reflect your unique install preferences for a specific project.',
  },
  {
    title: '*NEW* Labor Management',
    description:
      'Generate work orders with a single click that reflect a project’s specific installation needs.',
  },
];

const Features = () => (
  <InfoSection sectionTitle="Features" infoItems={INFO_ITEMS} numColumns={2} />
);

export default Features;
